import http from "../http-common";

class ProviderDataService {
    getAll(params = {}) {
        return http.get('/providers', { params });
    }

    getActive(params = {}) {
        return http.get('/providers', { params: { ...params, active_only: true } });
    }

    get(id) {
        return http.get(`/providers/${id}`);
    }

    create(data) {
        return http.post('/providers', data);
    }

    update(id, data) {
        return http.put(`/providers/${id}`, data);
    }

    delete(id) {
        return http.delete(`/providers/${id}`);
    }
}

export default new ProviderDataService();

